import {StorageUtils} from "xmgoing-utils";
import {ref} from "vue";
import GoingUtils from "@/utils/goingUtils";

export function useDatasSubListHooks(){
  //当前菜单的id
  const curMenuId=StorageUtils.getSessionItem("curMenuId");
  //子表的code
  const subGridCode=StorageUtils.getItem(curMenuId+'_pageSubGridCode');

  //是否查询子表明细标志
  const subGridListScopeFlag=ref(false);
  //子表明细的code
  const subGridListScopeVal=ref('');

  //如果存在当前菜单的子表编码
  if(subGridCode&&subGridCode.length>0&&curMenuId){
    subGridListScopeFlag.value=true;
    subGridListScopeVal.value=subGridCode;
  }

  /**
   * 对查询回来的数据进行加工处理
   * @param records
   */
  const initSubGridRecords=function (records){
    if(records&&Array.isArray(records)&&records.length>0){

    }
  }

  /**
   * 设置子表查询切换
   * @param subGridListScopeType
   * @param subGridListScope
   */
  const setSubGridQueryScope=function ({subGridListScope}){
    //当前菜单的id
    const curMenuId=StorageUtils.getSessionItem("curMenuId");
    if(curMenuId){
      if(subGridListScope&&subGridListScope.length>0){
        subGridListScopeFlag.value=true
        subGridListScopeVal.value=subGridListScope;
      }else{
        subGridListScopeFlag.value=false;
        subGridListScopeVal.value='';
      }
      StorageUtils.addItem(curMenuId+'_pageSubGridCode',subGridListScope)
    }else{
      GoingUtils.showWarningMsg("curMenuId为空，请到运行态验证！")
    }
  }

  return {
    setSubGridQueryScope,
    initSubGridRecords,
    subGridListScopeFlag,
    subGridListScopeVal,
  }
}
